import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store"
import LeftMenuLayout from "@/layouts/LeftMenuLayout.vue"
import { title, meta } from "@/constant/meta"
import i18n from "../i18n"
// 各画面定義
import Login from "../views/Login.vue"
import FailedSocialLogin from "../views/errors/FailedLogin.vue"
import Homework from "../views/Homework.vue"
import HomeworkRegister from "../views/HomeworkRegister.vue"
import HomeworkAddTextbookQuestion from "../views/HomeworkAddTextbookQuestion.vue"
import HomeworkAddStdbQuestion from "../views/HomeworkAddStdbQuestion.vue"
import HomeworkAddPdfQuestion from "../views/HomeworkAddPdfQuestion.vue"
import HomeworkProgress from "../views/HomeworkProgress.vue"
import Question from "../views/Question.vue"
import CommentControl from "../views/CommentControl.vue"
// エラー画面定義
import PageNotFound404Url from "../views/errors/PageNotFound.vue"
import BadRequest400Url from "../views/errors/BadRequest.vue"
import Forbidden403 from "../views/errors/Forbidden.vue"
import InternalServerError500Url from "../views/errors/InternalServerError.vue"
import ServiceUnavailable503Url from "../views/errors/ServiceUnavailable.vue"

Vue.use(VueRouter)

const routes = [
  {
    // デフォルトは、宿題管理 - 宿題一覧 を表示する
    path: "/",
    redirect: {
      name: "Homework",
    },
  },
  // AWS 用ルーティング定義
  {
    path: "/index.html",
    redirect: {
      name: "Homework",
    },
  },

  // ログイン画面
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: title.login,
      description: meta.description.login,
      keywords: meta.keywords.login,
      robots: meta.robots.login,
    },
  },
  // ログイン失敗時画面
  {
    path: "/failed_login",
    name: "FailedSocialLogin",
    component: FailedSocialLogin,
    meta: {
      title: title.socialLoginError,
      description: meta.description.socialLoginError,
      keywords: meta.keywords.socialLoginError,
      robots: meta.robots.socialLoginError,
    },
  },
  // Appleソーシャルログイン
  {
    path: "/social-login-apple",
    name: "SocialLoginApple",
    beforeEnter: () => {
      const param = `identity_provider=SignInWithApple&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Apple_${i18n.t(
        "labels.socialLogin.serviceId.sviewer"
      )}_${i18n.t("labels.socialLogin.appId.sviewer.lms")}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  // Googleソーシャルログイン
  {
    path: "/social-login-google",
    name: "SocialLoginGoogle",
    beforeEnter: () => {
      const param = `identity_provider=Google&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Google_${i18n.t(
        "labels.socialLogin.serviceId.sviewer"
      )}_${i18n.t("labels.socialLogin.appId.sviewer.lms")}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  // Microsoftソーシャルログイン
  {
    path: "/social-login-microsoft",
    name: "SocialLoginMicrosoft",
    beforeEnter: () => {
      const param = `identity_provider=Azure&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Microsoft_${i18n.t(
        "labels.socialLogin.serviceId.sviewer"
      )}_${i18n.t("labels.socialLogin.appId.sviewer.lms")}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  // Appleソーシャルログイン（STDB検索）
  {
    path: "/stdb-social-login-apple",
    name: "StdbSocialLoginApple",
    beforeEnter: () => {
      const param = `identity_provider=SignInWithApple&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Apple_${i18n.t(
        "labels.socialLogin.serviceId.stdb"
      )}_${process.env.VUE_APP_COGNITO_APPLIID_STDB}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  // Googleソーシャルログイン（STDB検索）
  {
    path: "/stdb-social-login-google",
    name: "StdbSocialLoginGoogle",
    beforeEnter: () => {
      const param = `identity_provider=Google&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Google_${i18n.t(
        "labels.socialLogin.serviceId.stdb"
      )}_${process.env.VUE_APP_COGNITO_APPLIID_STDB}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  // Microsoftソーシャルログイン（STDB検索）
  {
    path: "/stdb-social-login-microsoft",
    name: "StdbSocialLoginMicrosoft",
    beforeEnter: () => {
      const param = `identity_provider=Azure&redirect_uri=${
        process.env.VUE_APP_ACCOUNT_API_BASE_URL
      }/cognito/social/login&response_type=CODE&client_id=${
        process.env.VUE_APP_COGNITO_CLIENT_ID
      }&scope=email openid aws.cognito.signin.user.admin&state=Microsoft_${i18n.t(
        "labels.socialLogin.serviceId.stdb"
      )}_${process.env.VUE_APP_COGNITO_APPLIID_STDB}`
      window.location.href = `https://${process.env.VUE_APP_COGNITO_DOMAIN}.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?${param}`
    },
  },
  {
    path: "/succeeded_login",
    name: "SucceededSocialLogin",
    redirect: (to) => {
      return {
        name: "Login",
        query: null,
        params: {
          status: to.query.status,
          accountid: to.query.accountid,
          token: to.query.token,
        },
      }
    },
  },

  {
    path: "/management",
    component: LeftMenuLayout,
    children: [
      {
        // 宿題管理 - 宿題一覧
        path: "homework",
        name: "Homework",
        component: Homework,
        props: true,
        meta: {
          title: title.homework,
          description: meta.description.homework,
          keywords: meta.keywords.homework,
          robots: meta.robots.homework,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        // 宿題管理 - 宿題作成
        // 「mode」は操作モード（ブランク（空文字）：新規作成、edit：編集、copy：複製）
        path: "homework-register/:mode?",
        name: "HomeworkRegister",
        component: HomeworkRegister,
        props: true,
        meta: {
          title: title.homeworkRegister,
          description: meta.description.homeworkRegister,
          keywords: meta.keywords.homeworkRegister,
          robots: meta.robots.homeworkRegister,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        // 宿題管理 - 教材の問題を追加
        path: "homework-add-textbook-question",
        name: "HomeworkAddTextbookQuestion",
        component: HomeworkAddTextbookQuestion,
        meta: {
          title: title.homeworkAddTextbookQuestion,
          description: meta.description.homeworkAddTextbookQuestion,
          keywords: meta.keywords.homeworkAddTextbookQuestion,
          robots: meta.robots.homeworkAddTextbookQuestion,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        // 宿題管理 - 教材の問題(STDB)を追加
        path: "homework-add-stdb-question",
        name: "HomeworkAddStdbQuestion",
        component: HomeworkAddStdbQuestion,
        meta: {
          title: title.homeworkAddStdbQuestion,
          description: meta.description.homeworkAddStdbQuestion,
          keywords: meta.keywords.homeworkAddStdbQuestion,
          robots: meta.robots.homeworkAddStdbQuestion,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        // 宿題管理 - 教材の問題(PDF)を追加
        path: "homework-add-pdf-question",
        name: "HomeworkAddPdfQuestion",
        component: HomeworkAddPdfQuestion,
        meta: {
          title: title.homeworkAddPdfQuestion,
          description: meta.description.homeworkAddPdfQuestion,
          keywords: meta.keywords.homeworkAddPdfQuestion,
          robots: meta.robots.homeworkAddPdfQuestion,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        // 宿題管理 - 宿題進捗
        path: "homework-progress",
        name: "HomeworkProgress",
        component: HomeworkProgress,
        props: true,
        meta: {
          title: title.homeworkProgress,
          description: meta.description.homeworkProgress,
          keywords: meta.keywords.homeworkProgress,
          robots: meta.robots.homeworkProgress,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      {
        path: "question",
        name: "Question",
        component: Question,
        meta: {
          title: title.question,
          description: meta.description.question,
          keywords: meta.keywords.question,
          robots: meta.robots.question,
        },
        sviewer: {
          isAdmin: false,
        },
      },
      // コメント制御
      {
        path: "comment-control",
        name: "CommentControl",
        component: CommentControl,
        meta: {
          title: title.commentControl,
          description: meta.description.commentControl,
          keywords: meta.keywords.commentControl,
          robots: meta.robots.commentControl,
        },
        sviewer: {
          isAdmin: true,
        },
      },
    ],
  },

  // 共通エラー
  {
    path: "/error/:status",
    name: "APIError",
  },
  // 404 PAGE NOT FOUND
  {
    path: "/404_url",
    name: "PageNotFound404Url",
    component: PageNotFound404Url,
    meta: {
      title: title.errorPages.notFound,
      description: meta.description.errorPages.notFound,
      keywords: meta.keywords.errorPages.notFound,
      robots: meta.robots.errorPages.notFound,
    },
  },
  // 400 BAD REQUEST
  {
    path: "/400_url",
    name: "BadRequest400Url",
    component: BadRequest400Url,
    meta: {
      title: title.errorPages.badRequest,
      description: meta.description.errorPages.badRequest,
      keywords: meta.keywords.errorPages.badRequest,
      robots: meta.robots.errorPages.badRequest,
    },
  },
  // 403 FORBIDDEN
  {
    path: "/403_forbidden",
    name: "Forbidden403",
    component: Forbidden403,
    meta: {
      title: title.errorPages.forbidden,
      description: meta.description.errorPages.forbidden,
      keywords: meta.keywords.errorPages.forbidden,
      robots: meta.robots.errorPages.forbidden,
    },
  },
  // 500 INTERNAL SERVER ERROR
  {
    path: "/500_url",
    name: "InternalServerError500Url",
    component: InternalServerError500Url,
    meta: {
      title: title.errorPages.internalServerError,
      description: meta.description.errorPages.internalServerError,
      keywords: meta.keywords.errorPages.internalServerError,
      robots: meta.robots.errorPages.internalServerError,
    },
  },
  // 503 SERVICE UNAVAILABLE
  {
    path: "/503_url",
    name: "ServiceUnavailable503Url",
    component: ServiceUnavailable503Url,
    meta: {
      title: title.errorPages.serviceUnavailable,
      description: meta.description.errorPages.serviceUnavailable,
      keywords: meta.keywords.errorPages.serviceUnavailable,
      robots: meta.robots.errorPages.serviceUnavailable,
    },
  },
  // どれにもマッチしない場合は、「404 PAGE NOT FOUND」とする
  // ※このルーティングは最後に定義する必要がある
  {
    path: "/*",
    name: "PageNotFound",
    redirect: { name: "PageNotFound404Url" },
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

/** managementディレクトリ情報 */
const managementDirInfo = routes.find(v => v.path === "/management")

/** 先生用のページ名称一覧 */
const teacherPageNames = managementDirInfo.children.filter(v => !v.sviewer.isAdmin).map(v => v.name)

/** 管理者用のページ名称一覧 */
const adminPageNames = managementDirInfo.children.filter(v => v.sviewer.isAdmin).map(v => v.name)

/**
 * グローバルナビゲーションガード
 * 基本、処理を追加しない事
 * （非同期で動作したり、next を実行しても後続の処理が実行されたりするため）
 */
router.beforeEach((to, from, next) => {
  if (to.name === "APIError") {
    switch (to.params.status) {
      case 400:
        // 400 BAD REQUEST
        router.push({ name: "BadRequest400Url" })
        break
      case 403:
        // 403 FORBIDDEN
        router.push({ name: "Forbidden403" })
        break
      case 404:
        // 404 PAGE NOT FOUND
        router.push({ name: "PageNotFound404Url" })
        break
      case 500:
        // 500 INTERNAL SERVER ERROR
        router.push({ name: "InternalServerError500Url" })
        break
      case 503:
        // 503 SERVICE UNAVAILABLE
        router.push({ name: "ServiceUnavailable503Url" })
        break
      case 504:
        // 504 TIMEOUT ERROR
        router.push({ name: "InternalServerError500Url" })
        break
    }
    return false
  }

  const loginPageNames = [
    "Login",
    "FailedSocialLogin",
    "SocialLoginApple",
    "SocialLoginGoogle",
    "SocialLoginMicrosoft",
    "StdbSocialLoginApple",
    "StdbSocialLoginGoogle",
    "StdbSocialLoginMicrosoft",
  ]
  const errorPageNames = [
    "BadRequest400Url",
    "Forbidden403",
    "PageNotFound404Url",
    "InternalServerError500Url",
    "ServiceUnavailable503Url",
  ]
  
  // ログイン情報
  const loginUserInfo = store.getters.loginUserInfo

  // 遷移先情報(undefinedにしておくとリダイレクトなし)
  let nextPage = undefined

  if (errorPageNames.includes(to.name)) {
    // エラーページはそのまま遷移させる
  } else if (loginPageNames.includes(to.name)) {
    // ログイン画面はそのまま遷移させる
  } else if (!loginUserInfo.sessionToken) {
    // ログイン画面以外に遷移する場合、セッショントークンがなければログイン画面にリダイレクトする
    nextPage = { name: "Login" }
  } else {
    if (loginUserInfo.isAdmin) {
      // 管理者でログインの場合
      if (!adminPageNames.includes(to.name)) {
        // 管理者対象ページでない場合は管理者用ページにリダイレクト
        nextPage = { name: "CommentControl" }
      }
    } else {
      // 管理者以外(先生)でログインの場合
      if (!teacherPageNames.includes(to.name)) {
        // 先生対象ページでない場合は先生用ページにリダイレクト
        nextPage = { name: "Homework" }
      }
    }
  }

  next(nextPage)
})

export default router
